export const beautifyJsonString = (jsonString: string) => {
    let parsedJson = null
    try{
        parsedJson = JSON.parse(jsonString)
    }catch(e){e}
    return parsedJson ? JSON.stringify(parsedJson, null, 4) : jsonString
}
